import privacyModule from '../store/store';
import { PRIVACY_MODULE_STORE_NAME } from '../constants';

export default {
    install(Vue, options) {
        Vue.$store.registerModule(PRIVACY_MODULE_STORE_NAME, privacyModule);

        if (options.items) {
            Vue.$store.commit(`${PRIVACY_MODULE_STORE_NAME}/setRegisteredItems`, options.items);
        }

        if (options.component) {
            Vue.$store.commit(`${PRIVACY_MODULE_STORE_NAME}/setPrivacyConsentComponent`, options.component);
        }

        if (options.themeColor) {
            Vue.$store.commit(`${PRIVACY_MODULE_STORE_NAME}/setThemeColor`, options.themeColor);
        }
    },
};
